module.exports = __webpack_public_path__ + "c5727f2eb7386f212a643b53432bdd62.svg";